import React, { useEffect, useState, useRef } from "react";
import Spinner from "../../components/Tools/spinner";
import { useSelector } from 'react-redux';
import SubHeader from "../../components/Subheader/Subheader";
import CustomBreadcrumbs from "../../components/Tools/Breadcumbs";
import Box from '@mui/material/Box';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import FailedInvoices from "./components/FailedInvoices";
import FailedBeneficiaryReimbursement from "./components/FailedBeneficiaryReimbursement";
import FailedSalaries from "./components/FailedSalaries";


const FailedPaymentList = () => {
    const [loading, setLoading] = useState(false);
    const { financialYears, authData } = useSelector((state) => state.authData);
    const fyIdRef = useRef(localStorage.getItem('globalDateId'));
    const fyList = financialYears.payload.fy_list;
    const [value, setValue] = useState(0);
    const handlePageTrigger = () => {
        fyIdRef.current = localStorage.getItem('globalDateId');
    }
    const handleChange = (event, newValue) => {
        setValue(newValue);
    };
    
    
    return (
        <div>
            {loading && <div > <Spinner/> </div>}
            <SubHeader fy_list={fyList} handlePageTrigger={handlePageTrigger}/>
            <div className="row" style={{ padding: "10px 16px" }}>
                <div className="col-md-6">
                    <h4 style={{ color: "#28326f", margin:0}}>Failed Payments</h4>
                    <CustomBreadcrumbs linksArray={[]} title="Failed Payments"/>
                </div>
                <div className="col-md-6">
                    
                </div>
            </div>
            <Box sx={{ width: '100%', bgcolor: 'background.paper' }}>
                <Tabs value={value} onChange={handleChange} centered>
                    <Tab label="Failed Invoices" />
                    <Tab label="Failed Beneficiary Reimbursements" />
                    <Tab label="Failed Salaries" />
                </Tabs>
            </Box>
            {value === 0 && <FailedInvoices setLoading={setLoading} value={value}/>}
            {value === 1 && <FailedBeneficiaryReimbursement setLoading={setLoading} value={value}/>}
            {value === 2 && <FailedSalaries setLoading={setLoading} value={value}/>}
        </div>
    );
}

export default FailedPaymentList;